import { http, HttpResponse } from 'msw';

import { apiEndpoints } from '../../lib';

export const noLoanHandlers = {
  accountSummary: http.get(apiEndpoints.accountSummary(':accountId'), () => HttpResponse.json(
    {
      account_id: 12345,
      current_loan_type: 'installment',
      due_date_adjustment_eligible: true,
      first_name: 'John',
      last_name: 'Doe',
      login: 'johnedoe@gmail.com',
      show_fee_saver_status: true,
    },
    { status: 200 },
  )),
  // MSW matches on path only; strip the endpoint's ?active=true so it isn't a redundant matcher.
  loanSummary: http.get(apiEndpoints.activeLoanSummary(':accountId').split('?')[0], () => HttpResponse.json(
    {
      data: {},
    },
    { status: 200 },
  )),
};
